export function SingleScoDataMap( dataModel ){

    // lms values
    let scoData = new Map( dataModel );

    function set( dataModelId, value ) {

        if( !isInputValueValid( dataModelId, value ) ){
            return false;
        }

        scoData.set( dataModelId, value.toString() );
        return true;
    }

    /**
     *
     * @param dataModelId
     * @param value
     * @returns {boolean}  if dataModelId an already existing key of the map (@see dataModel) and value from type string or number.
     */
    function isInputValueValid( dataModelId, value ){

        if( !scoData.has( dataModelId ) ) {
            return false;
        }

        return typeof( value ) === "string" || typeof( value ) === "number";
    }

    function get( dataModelId ) {

        if( !scoData.has( dataModelId ) ){
            return null;
        }

        return scoData.get( dataModelId );
    }

    return {
        set: set,
        get: get,
        isValid: (dataModelId) => {
            return scoData.has( dataModelId );
        }
    };
}
